import React from 'react';
import cn from 'classnames';

import { getTranslation } from 'helpers/getTranslation';

import { Typography } from 'components/shared/Typography';

import { SUPPORTED_LANGUAGES, type SupportedLanguage } from 'constants/language';

import styles from './LanguageSwitcher.module.scss';

const LanguageSwitcher = ({
  className,
  activeLanguage,
  onLanguageChange,
}: {
  className?: string;
  activeLanguage: SupportedLanguage;
  onLanguageChange: (language: SupportedLanguage) => void;
}) => (
  <div
    className={cn(styles.root, className)}
    role="group"
    aria-label={getTranslation('components.language_switcher.aria_label')}
  >
    <div className={styles.tabs}>
      {SUPPORTED_LANGUAGES.map((language) => (
        <button
          key={language}
          type="button"
          className={cn(styles.tab, {
            [styles.tabActive]: activeLanguage === language,
          })}
          aria-pressed={activeLanguage === language}
          onClick={() => onLanguageChange(language)}
        >
          <Typography
            className={styles.label}
            variant="body2"
            weight="medium"
            mode="compact"
          >
            {getTranslation(`lesson_locale_tabs.${language}`)}
          </Typography>
        </button>
      ))}
    </div>
  </div>
);

export default React.memo(LanguageSwitcher) as any;
